import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { resolveSupportedLocale } from "../../lib/locale-preferences";
import { getRemoteDefinition } from "../../lib/remotes";
import { useAuthStore } from "../../state/auth-store";
import { useShellLocaleStore } from "../../state/shell-locale-store";
import { publishShellHostSnapshot } from "./runtime";

export const ShellHostContextBridge = () => {
  const location = useLocation();
  const user = useAuthStore((state) => state.user);
  const tenant = useAuthStore((state) => state.tenant);
  const apps = useAuthStore((state) => state.apps);
  const locale = useShellLocaleStore((state) => state.locale);
  const hydrateFromProfile = useShellLocaleStore(
    (state) => state.hydrateFromProfile,
  );
  const remoteAppKey = location.pathname.match(/^\/apps\/([^/]+)/)?.[1];
  const routeBase = getRemoteDefinition(remoteAppKey)?.route;
  const effectiveRole =
    apps.find((app) => app.key === remoteAppKey)?.effectiveRole ?? user?.role;
  const effectiveLocale = resolveSupportedLocale(user?.locale) ?? locale;

  useEffect(() => {
    hydrateFromProfile(user?.locale);
  }, [hydrateFromProfile, user?.locale]);

  useEffect(() => {
    if (!user?.id || !tenant?.id) {
      publishShellHostSnapshot({});
      return;
    }

    publishShellHostSnapshot({
      routeBase,
      locale: effectiveLocale,
      user: {
        id: user.id,
        name: user.name,
        email: user.email,
        dni: user.dni,
        role: effectiveRole,
      },
      tenant: {
        id: tenant.id,
        name: tenant.name,
        slug: tenant.slug,
        schema: tenant.schema,
      },
    });
  }, [effectiveLocale, effectiveRole, routeBase, tenant, user]);

  return null;
};
